@let value = rawValueSg();
@let valueInfo = valueInfoSg();
@let label = labelSg();

<div class="atn-value-readonly">
  <span
    ><b>{{ label }}</b></span
  >
  <atn-ds-value
    [value]="value"
    [valueInfo]="valueInfo"
  />
</div>
